import * as iOSBridge from "iOSBridge";

/**
 * Haptic feedback in the iOS app, used sparingly: a light tap translating a
 * word, success or failure answering a flashcard, success finishing a text or
 * meeting the day's goal. Nothing elsewhere. On
 * unless turned off in Settings, on this device.
 */
export type Haptic = "light" | "success" | "warning" | "error";

const offKey = "haptics.off";

export const isOn = () => localStorage.getItem(offKey) === null;

export const setOn = (on: boolean) => {
  if (on) {
    localStorage.removeItem(offKey);
  } else {
    localStorage.setItem(offKey, "true");
  }
};

export const play = (haptic: Haptic) => {
  if (isOn()) {
    iOSBridge.get()?.haptic(haptic);
  }
};
